import React, { useEffect, useState } from "react";
import { apiGet } from "../../utils/api";
import { articlesList } from "./ArticlesActions";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

const Articles = () => {
  const [articles, setArticles] = useState([]);
  const [category, setCategory] = useState("");

  // const category = new URLSearchParams(useLocation().search).get("category");

  useEffect(() => {
    async function exibir() {
      const { payload } = articlesList(category);
      setArticles((await payload).data.data);
    }
    exibir();
  }, [category]);

  const onChangeHandler = async (e) => {
    // e.target.value ---> pega o conteudo da caixa de texto que gerou o evento onChangeHandler
    const payload = apiGet("/article/s/pesquisar?termo=" + e.target.value);
    setArticles((await payload).data.data);
  };

  return (
    <div>
      <section id="producoes" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Artigos</h2>
        </div>

        <div className="row mx-5">
          <div className="col-md-4">
            <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
              <InputLabel id="select-label">Categoria</InputLabel>
              <Select
                labelId="select-label"
                id="simple-select"
                value={category}
                label="Categoria"
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
              >
                <MenuItem value="">
                  <em>Todas</em>
                </MenuItem>
                <MenuItem value={"Educação Profissional e Institutos Federais"}>
                  Educação Profissional e Institutos Federais
                </MenuItem>
                <MenuItem value={"Educação Profissional e Novos Caminhos EPT"}>
                  Educação Profissional e Novos Caminhos EPT
                </MenuItem>
                <MenuItem
                  value={"As Reformas da Educação Profissional e Tecnológica"}
                >
                  As Reformas da Educação Profissional e Tecnológica
                </MenuItem>
                <MenuItem
                  value={"Reforma do Ensino Médio e Educação Profissional"}
                >
                  Reforma do Ensino Médio e Educação Profissional
                </MenuItem>
                <MenuItem value={"Reformas de Educação Profissional e BNCC"}>
                  Reformas de Educação Profissional e BNCC
                </MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>

        <div class="row mx-5">
          <div className="col-md-4">
            <div class="search">
              <input
                type="text"
                id="form1"
                class="form-control"
                placeholder="Pesquise aqui..."
                onChange={(e) => onChangeHandler(e)}
              />
            </div>
          </div>
        </div>

        {articles && articles.length ? (
          articles.map((article) => {
            // console.log(article)
            return (
              <div class="row mx-5 posts" key={article.article_id}>
                <div class="card mb-3">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="card-body">
                        <h5 class="card-title">{article.title}</h5>
                        <p class="card-text m-0">
                          <small class="text-muted">{article.category}</small>
                        </p>
                        <p class="card-text m-0">
                          <small class="text-muted">{article.year}</small>
                        </p>

                        <p class="card-text m-0">
                          <small class="text-muted">{article.authors}</small>
                        </p>
                        <p class="card-text m-0">
                          <div className="artigo-link">
                            {article.dissemination_vehicle}
                            <br />
                            <a
                              className="link link--dia"
                              target="_blank"
                              rel="noopener noreferrer"
                              href={article.access_link}
                            >
                              Acessar a publicação
                            </a>
                          </div>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div class="row mx-5 posts">
            <div class="card mb-3">
              <div class="row">
                <div class="col-lg-12">
                  <div class="card-body">
                    <h5 class="card-title">
                      Nenhum artigo para esta pesquisa.
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default Articles;
